import React from "react";
import { connect } from "react-redux";
import { Dealer, Documents, Payment, Preview, Renter, Systems, Term } from "./";
import { fetchContract } from "@cb/duck/id";
import useInterval from "helpers/useInterval";

const ActiveStep = (props) => {
  const { step } = props;

  useInterval(() => {
    if (!props.id) return;
    props.dispatch(fetchContract(props.id, props.step));
  }, 45000);

  return (
    <div>
      {step == "dealer" && <Dealer />}
      {step == "documents" && <Documents />}
      {step == "payment" && <Payment />}
      {step == "preview" && <Preview />}
      {step == "renter" && <Renter />}
      {step == "systems" && <Systems />}
      {step == "term" && <Term />}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    id: state.id,
    step: state.activeStep,
  };
}

export default connect(mapStateToProps)(ActiveStep);
